import Vuex from 'vuex';

/*
 * Storage modules
 */
import modalStorage from './modules/modal';

Vue.use(Vuex);

/**
 * Web storage
 */
export default new Vuex.Store({
  modules: {
    modal: modalStorage,
  },
});



// WEBPACK FOOTER //
// ./templates/floor/assets/js/VueApplication/Storage/index.js